import axios from "axios";
import { toast } from "sonner";
import { BookOpen, ArrowUpRight, FileDown } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BOOKS = [
  { t: "T.A.C.C. Work Book", u: "https://www.amazon.com/dp/B0H5D49156" },
  { t: "T.A.C.C. Manual — Guide to Healing", u: "https://www.amazon.com/dp/B0G5286848" },
];

const downloadCompanion = async () => {
  try {
    const res = await axios.get(`${API}/downloads/companion`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = "TACC-Companion-Manual.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success("Companion Manual downloaded.");
  } catch {
    toast.error("Could not download. Try again.");
  }
};

export const DashboardBooks = ({ canDownload }) => (
  <>
    <div className="section-tag mb-6 mt-16">§ Your Books · Kindle</div>
    <div className="grid grid-cols-12 gap-4">
      {canDownload && (
        <button onClick={downloadCompanion} data-testid="dashboard-companion-download" className="tacc-card group col-span-12 p-6 flex items-center justify-between gap-4 text-left">
          <div className="flex items-center gap-4">
            <FileDown size={20} className="text-[#B45309]" />
            <div>
              <span className="font-heading text-lg tracking-tight block">The Companion Manual · PDF</span>
              <span className="text-[#78716C] text-sm">Download it, print it, write in it — works alongside the 8 modules.</span>
            </div>
          </div>
          <ArrowUpRight size={18} className="text-[#78716C] group-hover:text-[#B45309] transition-colors shrink-0" />
        </button>
      )}
      {BOOKS.map((b) => (
        <a key={b.u} href={b.u} target="_blank" rel="noreferrer" className="tacc-card group col-span-12 md:col-span-6 p-6 flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <BookOpen size={20} className="text-[#B45309]" />
            <span className="font-heading text-lg tracking-tight">{b.t}</span>
          </div>
          <ArrowUpRight size={18} className="text-[#78716C] group-hover:text-[#B45309] transition-colors" />
        </a>
      ))}
    </div>
  </>
);
